/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import * as VueGoogleMaps from 'vue2-google-maps'

// router setup
import router from './routes/router';
import store from "./store";
import VueSession from 'vue-session' // https://www.npmjs.com/package/vue-session
import {Formatting} from './util/formatting'
import {Camera} from './util/camera'
import {Data} from './util/data'
import VueObserveVisibility from 'vue-observe-visibility'
import VueGoogleHeatmap from 'vue-google-heatmap'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls';

// plugin setup
Vue.use(DashboardPlugin)
Vue.use(VueSession)
Vue.use(Formatting)
Vue.use(Camera)
Vue.use(Data)
Vue.use(VueObserveVisibility)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAq6EpN0DkLaGirArQKtKwxL0ajuddHowQ',
    libraries: 'places,visualization',
  },
  // load: false,
  installComponents: true
})
/*
Vue.use(VueGoogleHeatmap, {
  apiKey: 'AIzaSyAq6EpN0DkLaGirArQKtKwxL0ajuddHowQ'
})
*/
Vue.use(VueVideoPlayer, /* {
  options: global default options,
  events: global videojs events
} */)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/monitoring'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});


